export default __webpack_public_path__ + "img/joined_events_empty-ee3f63f5f105a7acbcddbd3041550e1d.png";